import { Duration } from "luxon";

export const formatDuration = (seconds: number | null): string => {
    if (!seconds) return "00:00";

    const duration = Duration.fromObject({ seconds });

    // If duration is less than an hour, return mm:ss format
    if (duration.as("hours") < 1) {
        return duration.toFormat("mm:ss");
    }

    // For durations with hours, return hh:mm:ss format
    return duration.toFormat("h:mm:ss");
};
